"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
function noop(..._args) { }
exports.noop = noop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9saWIvZnVuY3Rpb25zL25vb3AvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsU0FBZ0IsSUFBSSxDQUFDLEdBQUcsS0FBZ0IsSUFBUyxDQUFDO0FBQWxELG9CQUFrRCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBub29wKC4uLl9hcmdzOiB1bmtub3duW10pOiB2b2lkIHt9XG4iXX0=